import {Observable} from "rxjs";
import {finalize, tap} from "rxjs/operators";

export interface LoadsData {
  loading: boolean,
}

export function load<Class extends LoadsData, Key extends keyof Class, AsyncType extends Class[Key]>(
  work: Observable<AsyncType>,
  subject: Class,
  property?: Key
): Observable<AsyncType> {
  subject.loading = true;
  return work.pipe(
    tap(result => property ? subject[property] = result : null),
    finalize(() => subject.loading = false)
  );
}

export function trackLoadingOf<Class extends LoadsData, Type>(work: Observable<Type>, subject: Class, property = 'loading'): Observable<Type> {
  setTimeout(() => subject[property] = true, 0); // Prevent ChangeDetection errors
  return work.pipe(
    finalize(() => setTimeout(() => subject[property] = false, 0))
  );
}
export function trackLoadingOn<Class, Type>(
  work: Observable<Type>,
  subject: BooleanPropertiesOn<Class>,
  property: keyof BooleanPropertiesOn<Class>
): Observable<Type> {
  setTimeout(() => subject[property] = true, 0); // Prevent ChangeDetection errors
  return work.pipe(
    finalize(() => setTimeout(() => subject[property] = false, 0))
  );
}

type BooleanProperty<T> = { [P in keyof T]: T[P] extends boolean ? P : never }[keyof T];
type BooleanPropertiesOn<T> = { [k in BooleanProperty<T>]: boolean};
